module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/NB线 FlipChip： Wafer清洗+SSB植球机.7b4b85a5.png";